<template>
  <div v-if="isAdminOrSuperAdmin">
    <p><strong>Serveur de la BD: </strong>{{db_host}}</p>
    <p><strong>BD: </strong>{{db}}</p>
    Cette version est basée sur l'entrée git suivante: <br /><br />
    <pre>{{version}}</pre>
  </div>
</template>
<script>
import axios from 'axios';
import gitInfo from '!raw-loader!@/assets/gitInfo.txt';
import {privileges} from '@/mixins/privileges.js';

export default {
  data: function() {return {
    version: gitInfo,
    db_host: '',
    db: ''
  }},
  mixins: [privileges],
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/admin_version.php',
          { params: {}})
        .then(response => {
          this.db_host = response.data.db_host;
          this.db = response.data.db;
        })
    },
  },
  mounted () {
    this.refresh();
  }
}
</script>
